import SearchIcon from '@mui/icons-material/Search';
import InputAdornment from '@mui/material/InputAdornment';
import TextField from '@mui/material/TextField';
import ClearIcon from '@mui/icons-material/Clear';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import Tooltip from '@mui/material/Tooltip';
import { IconButton, Typography } from '@mui/material';

interface Props {
  searchValue: string;
  searchHeader: string;
  searchLabel: string;
  searchTooltipHtml: string;
  setHasTyped: (hasTyped: boolean) => any;
  setSearchValue: (searchValue: string) => any;
  clearCards: () => any;
  sm: Boolean;
}

const SearchBar: React.FC<Props> = ({
  searchValue,
  searchHeader,
  searchLabel,
  searchTooltipHtml,
  setSearchValue,
  clearCards,
  setHasTyped,
  sm,
}) => {
  return (
    <>
      <div className="lookup">
        {sm ? <h2>{searchHeader}</h2> : <h3>{searchHeader}</h3>}
        <div className="entry">
          <TextField
            id="outlines-basic"
            label={searchLabel}
            variant="outlined"
            value={searchValue}
            inputProps={{ maxLength: 500 }}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon />
                </InputAdornment>
              ),
              endAdornment: (
                <InputAdornment position="end">
                  <ClearIcon
                    sx={{ cursor: 'pointer' }}
                    onClick={() => {
                      setSearchValue('');
                      clearCards();
                    }}
                  />
                </InputAdornment>
              ),
            }}
            onChange={(e) => {
              setHasTyped(true);
              setSearchValue(e.target.value);
            }}
          />

          <Tooltip className="tooltip" title={<Typography variant="body1">{searchTooltipHtml}</Typography>}>
            <IconButton>
              <InfoOutlinedIcon sx={{ fontSize: '25px' }} />
            </IconButton>
          </Tooltip>
        </div>
      </div>
    </>
  );
};

export default SearchBar;
